"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_CUSTOMER_NOTE_LENGTH = exports.DEFAULT_DESTINATION_RADIUS = void 0;
// Constants from legacy/models
exports.DEFAULT_DESTINATION_RADIUS = 15;
exports.MAX_CUSTOMER_NOTE_LENGTH = 1024;
//# sourceMappingURL=models.js.map